module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAmCAYAAACCjRgBAAABAUlEQVRYhe2Y0Q7DIAhFYdn///LdUxfmSKV41Zhwkj7URuUWUFGkKIqj0UwnAP2BVQEgNb5qvNsrM0HAgL5CEnQBqgoJeIgFVcBq40VE3qyBPON7oZTNEQtFgPvne554kKh3DIfQjrCxDAsAoKy/mYESQgD0zxOLRNGS2BPBSNIe1GV0RzjRN7LVIqYcJVaEzsUUASLrREwTsIoSsJsSsJvjBWSXup/j58iS6dXOT2ri9FnITjpSwI9yfAjRTqMWW0q2nvLa7fennkwLuDPGC6/WuN57lCk5ELkXYuXQlHshAHo9kT7fYijBtiRuDc6KmLIPeMa17bbNCb99twRFcRgfNYagOoO+K9gAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/walleris/images/IEBACK_A.png
// module id = 65
// module chunks = 0